module.exports = __webpack_public_path__ + "static/media/welfare-share.75131b1f.jpg";